import React from 'react';
import { motion } from 'framer-motion';
import './Hero.css';

const Hero = () => {
  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openWhatsAppConsultation = () => {
    const whatsappNumber = '917984364765';
    const message = `Hi, I want to book a consultation. Please let me know your available slots and provide me with more details about your services.`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
        <img
          src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80"
          alt="Best skin clinic in Surendranagar Gujarat - Dr Vaibhav Moghariya Clinic dermatology treatments"
          className="hero-image"
        />
      </div>

      <div className="container">
        <div className="hero-content">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-text"
          >
            <h1 className="hero-title">
              Transform Your Skin,<br />
              <span className="gradient-text">Embrace Your Glow</span>
            </h1>
            <p className="hero-subtitle">
              Dr Vaibhav Moghariya Clinic - The biggest and most trusted skin clinic in Surendranagar district, Gujarat.
              Expert dermatologists offering advanced laser treatments, acne solutions, anti-aging therapies, and comprehensive skincare services.
            </p>
            <div className="hero-buttons">
              <button className="btn-primary" onClick={openWhatsAppConsultation}>Book Consultation</button>
              <button className="btn-secondary" onClick={scrollToServices}>View Services</button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="hero-features"
          >
            <div className="feature-card">
              <div className="feature-icon">✨</div>
              <h3>Expert Care</h3>
              <p>Certified dermatologists with years of experience</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>Advanced Technology</h3>
              <p>Latest equipment for safe and effective treatments</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💎</div>
              <h3>Premium Results</h3>
              <p>Visible improvements with personalized care</p>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="hero-stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <h3>1,40,000+</h3>
              <p>Happy Clients in Gujarat</p>
            </div>
            <div className="stat-item">
              <h3>7+</h3>
              <p>Years of Combined Experience</p>
            </div>
            <div className="stat-item">
              <h3>50+</h3>
              <p>Advanced Treatments</p>
            </div>
            <div className="stat-item">
              <h3>100%</h3>
              <p>Safe & Effective Results</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
